import { apiClient } from '../utils/api-client';

export interface NotificationItem {
  id: string;
  type: 'new_climb' | 'friend_climb' | 'user_climb' | 'first_top' | 'mention' | 'send_comment' | 'send_thread_comment' | 'new_follower' | 'badge_earned' | 'video_liked' | 'new_video' | 'climb_reported_removed' | 'schedule_registration_created' | 'gym_member_linked' | 'gym_member_registered';
  attributes: {
    title: string;
    message: string;
    image_url: string | null;
    timestamp: string;
    viewed: boolean;
    url: string | null;
    subject: {
      type: string;
      id: string;
    };
    /** schedule_registration_created: whether the registration still needs confirming. */
    requires_confirmation?: boolean;
    /** schedule_registration_created: id used to confirm the registration. */
    registration_id?: string | null;
  };
}

export interface NotificationsResponse {
  data: NotificationItem[];
  meta: {
    next_before: string | null;
    has_more: boolean;
  };
}

class NotificationService {
  async getNotifications(before?: string, limit: number = 25): Promise<NotificationsResponse> {
    const params = new URLSearchParams();
    if (before) params.append('before', before);
    params.append('limit', limit.toString());

    const response = await apiClient.get(
      `/api/notifications?${params.toString()}`,
      { requireAuth: true }
    );

    if (!response.ok) throw new Error('Failed to fetch notifications');
    return response.json();
  }

  async getUnreadCount(): Promise<number> {
    const response = await apiClient.get(
      '/api/notifications/unread_count',
      { requireAuth: true }
    );
    if (!response.ok) return 0;
    const data: { data: { unread_count: number } } = await response.json();
    return data.data.unread_count;
  }

  async markViewed(ids?: string[]): Promise<void> {
    const body = ids ? { data: { ids } } : { data: {} };
    await apiClient.patch('/api/notifications/mark_viewed', body, { requireAuth: true });
  }
}

export const notificationService = new NotificationService();
